<template>
  <v-card class="project-wrapper mb-4">
    <v-card-title>
      <a :href="'http://10.202.19.4/dashboard?id=' + project.key">
        <span class="project-name">{{ project.name }}</span>
        <v-icon>mdi-open-in-new</v-icon>
      </a>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col col="4">
          <div class="coverage">
            <v-progress-circular
              :value="coverage.value"
              :color="coverage.color"
            >
            </v-progress-circular>
            <span class="coverage-value ml-2">{{ coverage.label }}</span>
          </div>
          <p class="mt-2">
            <strong>Coverage on {{ lines }} lines</strong>
          </p>
        </v-col>
        <v-col col="2" class="text-center">
          <rating-badge
            :metric="measures.sqale_rating.label"
            :rating="measures.sqale_rating.value"
          ></rating-badge>
        </v-col>
        <v-col col="2" class="text-center">
          <rating-badge
            :metric="measures.reliability_rating.label"
            :rating="measures.reliability_rating.value"
          ></rating-badge>
        </v-col>
        <v-col col="2" class="text-center">
          <rating-badge
            :metric="measures.security_rating.label"
            :rating="measures.security_rating.value"
          ></rating-badge>
        </v-col>
        <v-col col="2" class="text-center">
          <rating-badge
            :metric="measures.security_review_rating.label"
            :rating="measures.security_review_rating.value"
          ></rating-badge>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import RatingBadge from '../../components/RatingBadge.vue'
export default {
  components: { RatingBadge },
  name: 'ProjectCard',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
    lines() {
      return this.measures.lines ? `${this.measures.lines.value}` : 'N/A'
    },
    coverage() {
      const cov = this.measures.coverage ? this.measures.coverage.value : 0
      const obj = {
        value: cov,
        label: `${cov.toFixed(2)}%`
      }
      if (cov < 20) {
        obj.color = 'rating_E'
      } else if (cov < 40) {
        obj.color = 'rating_D'
      } else if (cov < 60) {
        obj.color = 'rating_C'
      } else if (cov < 80) {
        obj.color = 'rating_B'
      } else {
        obj.color = 'rating_A'
      }
      return obj
    },
    measures() {
      const measures = this.project.analyses.component.measures
      return measures.reduce((res, m) => {
        res[m.metric] = {
          value: parseFloat(m.value, 10),
          label: this.ratings[m.metric]
        }
        return res
      }, {})
    }
  },
  data() {
    return {
      ratings: {
        sqale_rating: 'Maintainability',
        security_rating: 'Security',
        reliability_rating: 'Reliability',
        security_review_rating: 'Security Review'
      }
    }
  }
}
</script>

<style scoped>
.coverage {
  line-height: 1;

  font-size: 36px;
  white-space: nowrap;
}
</style>
